export const api_version = 1;
export const app_version = '1.0'; 
export const build = '2026.03.11.15.20';
export const dev_env = false;
export const dev_setter = false;
export const dev_sales_ops = false;
export const stripe_dev_env = false;

// prepare server using staging and dev flags
export const staging = false;
export const server = dev_env ? 'http://lifewipe-sales.local.192.168.4.158.sslip.io' : (staging ? 'https://staging.life-wipe.com' : 'https://sales.life-wipe.com');

export default {
    app_version,
    build,
    dev_env,
    dev_sales_ops,
    dev_setter,
    mapbox: 'pk.eyJ1IjoibGxpZmV3aXBlIiwiYSI6ImNtZnk5czlpNjBqbDgya243a2k3YnQ5b3MifQ.90xPB8sXhLAB7OytOO2dMQ',
    server,
    sockets: dev_env ? `${server}:4000` : `https://websockets.sales.life-wipe.com`,
    stripe: stripe_dev_env ? 'pk_test_51SxWPN23WGOdDyiDIWbpFizb1fv0h6JyJL4Df2mL7EtqYy87zji3YdAOdlVCqNpQRc5DZzj4E8vE6GIEmIT9tn3800lrTdtmrH' : 'pk_live_51RGrwIP0PN0uxnyKnyLnDbPIb6P72n0ZYGI3EZ5X9rekOKlqd7ai3ecEB3SpT1S3kzxnzMVw4f1zroMzkXoRhTkq00cN8XDvfX',
    stripe_dev_env,
    url: `${server}/api/v${api_version}`,
    version: api_version,
    website: 'https://life-wipe.com'
}
